import React, { useState, useEffect, Fragment } from "react";
import { EditableArea } from "@magnolia/react-editor";
import { connect } from "react-redux";
import { multilanguage } from "redux-multilanguage";
import { useDetailPageQuery } from "../../../utils/location";
import { wfetch } from "../../../utils/fetch";
import { environment } from "../../../environment";
import { DYNAMIC_PAGE_QUERY_KEYS } from "../../../utils/constants/pagePaths";
import { getCategory, getMerchandising } from "../../../services/categories.service";
import { applyMerchandising, filterProductsByCategoryIds, getProducts } from "../../../services/products.service";
import Breadcrumb from "../../../components/magnolia/breadcrumb/Breadcrumb";
import HtmlHeader from "../../../components/magnolia/htmlHeader/HtmlHeader";
import ProductList from "../../../components/magnolia/productList/ProductList";

const ProductOverview = ({ currentLanguageCode, main, title, meta, geo }) => {
    const [category, setCategory] = useState({});
    const [products, setProducts] = useState([]);
    // The URL carries either:
    //   /productOverview?category=men           (legacy / JCR — name-based)
    //   /productOverview?category=<id>&source=salesforce-sfcc (multi-source)
    // We honour the `source` param and dispatch fetches to the matching backend.
    const { id: categoryId, source } = useDetailPageQuery(DYNAMIC_PAGE_QUERY_KEYS["PRODUCT_OVERVIEW"]);

    useEffect(() => {
        // Mirrors what demo-ftl-ecommerce/templates/components/category/category.ftl does:
        // the delivery API's `?category=<uuid>` filter only matches products that
        // tag *that exact* node — useless when the URL points at a folder (e.g.
        // `/manufacturing`) whose products live under nested ecommerce-categories.
        // Walk @nodes to collect all descendant category UUIDs, fetch every product,
        // then filter client-side.
        async function fetchData() {
            const currentCategory = await getCategory({ lang: currentLanguageCode, source, categoryId });

            if (!currentCategory) return;

            setCategory(currentCategory);

            const productNodes = await getProducts({ lang: currentLanguageCode, source, category: currentCategory });

            if (!productNodes) return;

            // Apply the editor's curated merchandising order; products not listed keep default order.
            const merch = await getMerchandising({ source, categoryId, category: currentCategory });

            setProducts(applyMerchandising(productNodes, merch));
        }

        if (!categoryId) return;

        fetchData();
    }, [currentLanguageCode, categoryId, source]);

    return (
        <Fragment>
            <HtmlHeader title={category ? category.label || category["@name"] : title} meta={meta} geo={geo} />
            <Breadcrumb />
            <ProductList products={products} />
            {main && <EditableArea content={main} />}
        </Fragment>
    );
};

export default connect()(multilanguage(ProductOverview));
